<template>
  <div class="main-content bg-pos">
    <!-- Navbar -->
    <NavbarPos :userLogin="userlogin" :shopSetting="shop_setting" />
    <BlockUI v-if="busy">
      <div class="loader"></div>
    </BlockUI>
    <div id="el-banner"></div>
    <!-- Page content -->
    <div class="container-fluid pb-5 pos overflow-hidden">
      <slide-y-up-transition mode="out-in" origin="center top">
        <!--    比较计算价格    -->
        <CheckPricePage v-if="posPage.step == 'CHECKPRICE'" :busy="busy"  />
        <div class="row justify-content-center" v-if="posPage.step == 'FIRST'">
          <!-- box-รายการสินค้า -->
          <div :class="showCart === 'non-slide' ? '' : 'pr-0'" class="col-md col-xl smooth-trans">
<!--            快递公司组件-->
            <SelectService @fnGetPosRecentlyList="fnGetPosRecentlyList" :cashNumberInfo="cashNumberInfo" :showCart="showCart" @openCartComponent="openCartComponent($event)" :agentInfo="agentInfo" />
          </div>
          <!-- box-ตารางสินค้า -->
          <div :class="showCart === 'non-slide'
            ? 'dialog col-md-6 col-xl-5 pos-r-lg-max'
            : 'dialog-reverse-pos col-md-1 col-xl-1 pl-0 max-width-fix'">
              <CartComponent
                  :cashNumberInfo="cashNumberInfo"
                  :showCart="showCart"
                  @slideCart="slideDialog"
                  @checkThemeQuick="checkThemeQuick"
                  @openCartComponent="openCartComponent($event)"
                  :members="members"
                  @showAddReceiverInfo="showAddReceiverInfo"
                  :total="total"
                  :isSettleMent="isSettleMent"
                  @fnGetPosRecentlyList="fnGetPosRecentlyList"
                  @fnCreateCashNum="fnCreateCashNum"
                  :cashInfo="cashInfo"
                  :sender="sender"></CartComponent>
          </div>
        </div>
      </slide-y-up-transition>
    </div>
    <!-- 添加收件人信息 -->
    <AddReceiverInfo :cashNumberInfo="cashNumberInfo" @fnGetPosRecentlyList="fnGetPosRecentlyList" ref="addReceiverInfo" :activeCourierItem="activeCourierItem"></AddReceiverInfo>
  </div>
</template>
<script>
import NavbarPos from "@/components/custom/pos/NavbarPos.vue";
import { SlideYUpTransition } from "vue2-transitions";
import {getAgentInfo} from "@/api/login";
import CheckPricePage from "@/components/custom/pos/CheckPricePage.vue";
import {getStepPage} from "@/plugins/posHelper";
import SelectService from "@/views/Pos/components/SelectService.vue";
import CartComponent from "@/views/Pos/components/cartComponent.vue";
import {getPosDetailByCashNum, getPosRecentlyList,createCashNum} from "@/api/express";
import AddParcelInfo from "@/views/Pos/components/addParcelInfo.vue";
import AddReceiverInfo from "@/views/Pos/components/AddReceiverInfo.vue";
export default {
  components:{
    AddReceiverInfo,
    AddParcelInfo,
    CartComponent,
    SelectService,
    CheckPricePage,
    NavbarPos,
    SlideYUpTransition
  },
  data(){
    return {
      userlogin: [],
      shop_setting: {
        how_to_use_cod: false,
      },
      busy:false,
      showCart: "non-slide",
      posPage: {
        step: 'FIRST',
      },
      courierTeleport: {
        show: false,
      },
      agentInfo:{},
      sender:{},
      cashNumberInfo:{},
      members:[],
      total:0,
      isSettleMent:false,
      cashInfo:{},
      editOrderInfo:{},
      activeCourierItem:{}
    }
  },
  created(){
    this.getAgentInfo()
    this.getUserlogin()
    this.fnGetPosRecentlyList()
    this.sender = localStorage.getItem("senderInfo")?JSON.parse(localStorage.getItem("senderInfo")):{}
  },
  methods:{
    openCartComponent(key) {
      this.showCart = key
    },
    checkThemeQuick() {
      return this.$THEME.name == 'quickexpress';
    },
    slideDialog(key) {
      this.showCart = key
      let timeout
      clearTimeout(timeout)
      timeout = setTimeout(() => {
        this.showCart = ""
      }, 350)
    },
    // 获取代理商用户信息
    getUserlogin() {
      this.userlogin = this.$store.state.loginUser
      console.log(this.userlogin)
    },
    getAgentInfo(){
      getAgentInfo()
          .then((res) => {
            this.agentInfo = res.data
          })
    },
    // 打开寄件人弹窗
    async openModal(courier, preBarcode) {
      console.log('1111')
      this.busy = true
      if (this.sender.name != '') {
        this.from.name = this.sender.name
        this.from.address = this.sender.address
        this.from.state = this.sender.state
        this.from.district = this.sender.district
        this.from.province = this.sender.province
        this.from.postcode = this.sender.postcode
        this.from.tel = this.sender.tel
        this.titleName = "ที่อยู่ตามบัตรประชาชน"
      }
      this.$refs.modalSender.$refs['modal-idcard'].show()
      this.busy = false
    },
    // 获取或创建cashNum
    fnGetPosRecentlyList(){
      this.busy = true
      getPosRecentlyList()
          .then((res) => {
            this.$store.commit('SET_CASH_NUM', res.data.cashNum);
            this.fngetPosDetailByCashNum(res.data.cashNum)
          })
    },
    // 获取CashNum 对应包裹
    fngetPosDetailByCashNum(cashNum){
      getPosDetailByCashNum({
        cashNum:cashNum,
        isError:false,
        isHaveShop:true
      })
          .then((res) => {
            this.cashNumberInfo = res.data
            this.members =res.data.detail
            this.cashInfo = res.data
            this.total = res.data.sumAmount
            if (res.data.payStatus === 1 || !res.data.payStatus){
              this.isSettleMent = false
            }else{
              this.isSettleMent = true
            }
            this.busy = false
          })

    },
    // 创建收银任务
    fnCreateCashNum(){
      let msgAlert = ''
      if (this.cashInfo.payStatus === 1){
        msgAlert = 'รายการที่คุณมีอยู่ขณะนี้จะถูกยกเลิก คุณแน่ใจที่จะยกเลิกรายการทั้งหมด ?'
      }else if(this.cashInfo.payStatus === 2){
        msgAlert = 'คุณต้องการจะเปิดบิลใหม่';
      }
      this.$bvModal
          .msgBoxConfirm(`${msgAlert} `, {
            title: "กรุณายืนยัน",
            size: "sm",
            buttonSize: "sm",
            okVariant:  this.cashInfo.payStatus === 1? "danger" : "success",
            okTitle: "ยืนยัน",
            cancelTitle: "ยกเลิก",
            contentClass: "modal-confirm",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true
          })
          .then(value => {
            createCashNum()
                .then((res) => {
                  console.log(res.data[0].cashNum)
                  this.$store.commit('SET_CASH_NUM', res.data[0].cashNum);
                  localStorage.setItem("senderInfo", '')
                  this.fngetPosDetailByCashNum(res.data[0].cashNum)
                })
          })
    },
    // 添加收件人及包裹信息
    showAddReceiverInfo(item){
      console.log(item)
      this.$refs.addReceiverInfo.showAddReceiverInfo(item)
    },
  }
}
</script>
